var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRarFileTypeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101010;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xxx-word"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,105H250a5,5,0,0,1-5-5V25a5,5,0,1,1,10,0V95h70a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,154.83a5,5,0,0,1-5-5V102.07L247.93,30H100A20,20,0,0,0,80,50v98.17a5,5,0,0,1-10,0V50a30,30,0,0,1,30-30H250a5,5,0,0,1,3.54,1.46l75,75A5,5,0,0,1,330,100v49.83A5,5,0,0,1,325,154.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300,380H100a30,30,0,0,1-30-30V275a5,5,0,0,1,10,0v75a20,20,0,0,0,20,20H300a20,20,0,0,0,20-20V275a5,5,0,0,1,10,0v75A30,30,0,0,1,300,380Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,280H125a5,5,0,1,1,0-10H275a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,330H125a5,5,0,1,1,0-10h75a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325,280H75a30,30,0,0,1-30-30V173.17a30,30,0,0,1,30-30h.2l250,1.66a30.09,30.09,0,0,1,29.81,30V250A30,30,0,0,1,325,280ZM75,153.17a20,20,0,0,0-20,20V250a20,20,0,0,0,20,20H325a20,20,0,0,0,20-20V174.83a20.06,20.06,0,0,0-19.88-20l-250-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.89,236H161.74l-8.28-21.91H139.94V236h-9.61V182.68h23.13q9.65,0,14.18,4.36a14.94,14.94,0,0,1,4.53,11.27q0,10.27-9.61,14.14Zm-32-29.61h12q5.19,0,7.73-2.19a7.52,7.52,0,0,0,2.54-6,7.16,7.16,0,0,0-2.5-5.68,10.34,10.34,0,0,0-7-2.17H139.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.57,236H213.3L209,223.3H188.54L184.36,236h-8.2l17.7-53.32h11.84Zm-17.11-20.39-7.77-23.79-7.77,23.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.54,236H261.39l-8.28-21.91H239.59V236H230V182.68h23.13q9.65,0,14.18,4.36a14.94,14.94,0,0,1,4.53,11.27q0,10.27-9.61,14.14Zm-32-29.61h12q5.19,0,7.73-2.19a7.52,7.52,0,0,0,2.54-6,7.16,7.16,0,0,0-2.5-5.68,10.34,10.34,0,0,0-7-2.17H239.59Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarFileTypeSvgrepoCom);
export default __webpack_public_path__ + "static/media/rar-file-type-svgrepo-com.069f98cb53daf0fbf29bfa8f0c7fcd5a.svg";
export { ForwardRef as ReactComponent };